import React from 'react';

/**
 * Logo Petronect oficial (asset do PPT/marca).
 * Cores da wordmark ficam no PNG; a órbita já vem no arquivo.
 */
const PetronectLogo: React.FC<{ className?: string; title?: string }> = ({
  className,
  title = 'Petronect',
}) => (
  <img
    className={className ? `cab-cco-petronect-logo ${className}` : 'cab-cco-petronect-logo'}
    src="/cab-cco/petronect-logo.png"
    alt={title}
    draggable={false}
  />
);

type PetronectMarkProps = {
  className?: string;
  /** Branca no rail azul; verde na capa cinza (assets oficiais do PPT CCO-531). */
  variant?: 'white' | 'green';
};

/** Marca play + órbita do PPT (não SVG improvisado). */
export const PetronectMark: React.FC<PetronectMarkProps> = ({
  className,
  variant = 'green',
}) => (
  <img
    className={className ? `cab-cco-petronect-mark ${className}` : 'cab-cco-petronect-mark'}
    src={variant === 'white' ? '/cab-cco/petronect-mark-white.png' : '/cab-cco/petronect-mark-green.png'}
    alt=""
    aria-hidden="true"
    draggable={false}
  />
);

export default PetronectLogo;
